import { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import s from './styles.module.scss';

const Loading: FC = () => {
	return (
		<Box className={s.wrapper}>
			<Typography variant="h4">Завантаження...</Typography>
			<CircularProgress color="success" />
		</Box>
	);
};

export default Loading;
